var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Offers = MDB.DPN.Offers || {};

(function ($) {
    var offers = $('#offers');
    var addSelectedButton = $('#btn-select');
    var selectedOffers = $('#selected-offers');
    var crudServiceBaseUrl = document.location.origin + '/api/DPN/Offers';
    var channelGroupForm = $('#channel-group-form');
    var channelSelector = channelGroupForm.find('select[name$="Channel"]');

    $.extend(MDB.DPN.Offers, {
        _channelGroupBatchId: '',
        
        bootChannelGroupSearch: function () {
            MDB.DPN.Offers._channelGroupBatchId = MDB.guid();
            
            channelSelector.on('change', function () {
                MDB.DPN.Offers.toggleReferencedDropdowns(this.value);
            });

            MDB.DPN.Offers.toggleReferencedDropdowns(channelSelector.val());
            
            MDB.DPN.Offers.bootSimpleSearch(function (config) {
                config.columns.unshift({
                    title: 'Selected',
                    template: MDB.KendoConfigBuilder.gridCheckboxTemplate('IsSelected', 'selected', false)
                });
            });
            
            var offersPerChannelDataSource = new kendo.data.DataSource({
                transport: {
                    read: function(opts) {
                        var url = crudServiceBaseUrl + '/OffersPerChannel?' + channelGroupForm.find('select').serialize().replace(/OffersPerChannelSearch\./g, '');
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'GET', opts).done(function () {
                            MDB.KendoConfigBuilder.goBackToLastPageIfGridIsEmpty(offersPerChannelGridConfig);
                        });
                    },
                    create: function(opts){
                        opts.data.BatchId = MDB.DPN.Offers._channelGroupBatchId;
                        
                        var url = crudServiceBaseUrl + '/OffersPerChannel?' + channelGroupForm.find('select').serialize().replace(/OffersPerChannelSearch\./g, '');
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'POST', opts);
                    },
                    update: function(opts){
                        opts.data.BatchId = MDB.DPN.Offers._channelGroupBatchId;
                        
                        var url = crudServiceBaseUrl + '/OffersPerChannel?' + channelGroupForm.find('select').serialize().replace(/OffersPerChannelSearch\./g, '');
                        MDB.KendoConfigBuilder.dataSourceTransportFunction(url, 'PUT', opts);
                    }
                },
                pageSize: 20,
                schema: {
                    model: {
                        id: 'Prke',
                        fields: {
                            BatchId: {},
                            Prke: {type: 'number'},
                            Description: {},
                            Premium: {},
                            Duration: {type: 'number'},
                            DurationUnit: { },
                            Discount: {type: 'number'},
                            Price: {type: 'number'},
                            OfferType: {},
                            Channel: {}
                        }
                    }
                }
            });

            var offersPerChannelGridConfig = {
                dataSource: offersPerChannelDataSource,
                pageable: true,
                autoBind: true,
                columns: [
                    {
                        field: 'Prke',
                        title: 'Prke'
                    },{
                        field: 'Description',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Description_DisplayName')
                    },{
                        field: 'Premium' ,
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Premium_DisplayName')
                    },{
                        field: 'Duration',
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Duration_DisplayName')
                    },{
                        field: 'DurationUnit',
                        title: MDB.loadResourceString('DPN_Offers_Search_DurationUnit_Header')
                    },{
                        field: 'Price' ,
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Price_DisplayName'),
                        format: '€ {0:n2}'
                    },{
                        field: 'PriceUnit',
                        title: MDB.loadResourceString('DPN_Offers_Search_PriceUnit_Header')
                    }, {
                        field: 'Discount' ,
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_Discount_DisplayName'),
                        format: '{0:p}'
                    },{
                        field: 'OfferType' ,
                        title: MDB.loadResourceString('OffersSearchResultsViewModel_OfferType_DisplayName')
                    },{
                        field: 'Channel' ,
                        title: 'Kanaal'
                    }
                ],
                messages: {
                    commands: MDB.KendoConfigBuilder.commandLabels(),
                    noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
                },
                navigatable: true,
                sortable: { mode: 'multiple' },
                scrollable: false,
                editable: {
                    mode: 'inline'
                }
            };
            
            var wegenerTitles = MDB.DPN.Offers.getTitles('p5');
            var dpnTitles = MDB.DPN.Offers.getTitles('dpn');
            var babTitltes = MDB.DPN.Offers.getTitles('bab');

            // var adTitles = ['AD', 'ADR'];

            //ADR is a special case
            dpnTitles.splice(dpnTitles.indexOf('AD') + 1, 0, 'ADR');
            wegenerTitles.splice(0, 0, 'WEG');
            
            _.union(dpnTitles, wegenerTitles, babTitltes).forEach(function (t) {
                var htmlClass = 'product';

                // var isAd = adTitles.indexOf(t) !== -1;
                var isWegenerToggle = t === 'WEG';

                if (wegenerTitles.indexOf(t) !== -1){
                    htmlClass += ' wegener';
                    
                    if (isWegenerToggle){
                        htmlClass = 'wegener-toggle';
                        //return;
                    }
                }

                offersPerChannelDataSource.options.schema.model.fields[t] = {type: 'boolean'};
                offersPerChannelGridConfig.columns.push({
                    field: t,
                    template: function (model) {

                        //For regular titles, check if title is enabled
                        //For ADR/ADL, check if AD is enabled
                        //For WEG toggle, check if any WEG product is enabled
                        var checkedProducts = [t];
                        // if (isAd) checkedProducts = checkedProducts.concat(adTitles);
                        if (isWegenerToggle) {
                            checkedProducts = checkedProducts.concat(wegenerTitles);
                        }
                        
                        //Don't automatically disable an already enabled checkbox
                        var isEnabled = model[t] || _.intersection(model.EnabledProducts, checkedProducts).length !== 0;
                        
                        return kendo.template(MDB.KendoConfigBuilder.gridCheckboxTemplate(t, htmlClass, !isEnabled))(model);
                    },
                    title: MDB.DPN.Offers.gridDisplayNameForTitle(t)
                });
            });

            selectedOffers.kendoGrid(offersPerChannelGridConfig);

            channelGroupForm.find('.btn-form-submit').on('click', function(){
                //'Start' a new batch before syncing
                //BatchId will get added prior to the dataset prior to sending data to remote
                MDB.DPN.Offers._channelGroupBatchId = MDB.guid();
                
                offersPerChannelDataSource.sync().done(function() {
                    MDB.alert(MDB.loadResourceString('Offers_OffersPerChannel_Save_Success'));
                });
            });

            channelGroupForm.find('select').on('change', function () {
                offersPerChannelDataSource.read().done(function() {
                    var pages = offersPerChannelDataSource.totalPages();

                    if (pages < offersPerChannelDataSource.page()) {
                        offersPerChannelDataSource.page(pages);
                    }
                });
            });


            addSelectedButton.on('click', function(e){
                //Due to the button being located inside a form
                //We have to prevent the search form from submitting
                e.preventDefault();

                var offersDataSource = offers
                    .data('kendoGrid')
                    .dataSource;
                
                var offerAdded = false;
                var rowProms = [];

                offers.find('tr').filter(function () {
                    return $(this).find('.selected').prop('checked') === true; 
                })
                    .each(function () {
                        var modelId = this.getAttribute('data-uid');
                        var model = offersDataSource.getByUid(modelId);
                        var fields = offersPerChannelDataSource.options.schema.model.fields;

                        //Don't add duplicates
                        if (offersPerChannelDataSource.get(model.Prke)){
                            return;
                        }
    
                        Object.keys(fields).forEach(function(key){
                            //Ensure all fields are at least defined
                            if(model[key] === undefined) {
                                model[key] = undefined;
                            }
                        });
                        
                        model['Channel'] = channelSelector.val();

                        var productsPerOfferProm = MDB.DPN.Offers.getPrkeProductsPerOffer(model.Prke);
                        rowProms.push(productsPerOfferProm);

                        productsPerOfferProm.done(function(records) {
                            model.EnabledProducts = _.uniq(_.map(records, 'Title'));

                            model = offersPerChannelDataSource.add(model);
                            offersPerChannelDataSource.getByUid(model.uid).diry = true;
                        });

                        offerAdded = true;
                    });

                if (offerAdded) {
                    //All all rows should be added prior to potentially switching pages
                    $.when.apply($, rowProms).then(function() {
                        offersPerChannelDataSource.page(offersPerChannelDataSource.totalPages());
                    });
                }
            });

            $(selectedOffers).on('click', '.product', function(){
                var $this = $(this) 
                    , cell = $this.closest('td')
                    , row = cell.closest('tr')
                    , rowId = row.data('uid')
                    , field = $this.data('field')
                    , sourceRow = offersPerChannelDataSource.getByUid(rowId);

                var wegenerProducts = row.find('.wegener');
                var checkedProducts = wegenerProducts.filter(function () {
                    return this.checked; 
                });
                
                var allWegenerTitlesChecked = checkedProducts.length === wegenerProducts.length;
                
                sourceRow[field] = this.checked;
                sourceRow['WEG'] = allWegenerTitlesChecked;
                sourceRow.dirty = true;

                row.find('[data-field="WEG"]').prop('checked', allWegenerTitlesChecked);
            });
            
            $(selectedOffers).on('click', '.wegener-toggle', function (e) {
                var $this = $(this)
                    , row = $this.closest('tr');
                
                var checkedVal = this.checked;
                
                var wegenerProducts = row.find('.wegener');
                var selectedProducts = wegenerProducts.filter(function () {
                    return this.checked !== checkedVal;
                });
                
                if (selectedProducts.length === 0){
                    selectedProducts = wegenerProducts;
                }

                selectedProducts.each(function (){
                    $(this).trigger('click');  
                });
            });
        },
        toggleReferencedDropdowns: function (reference) {
            var referencedItems = $('.referenced');
            referencedItems.addClass('hidden');
            referencedItems.attr('disabled', 'disabled');
            
            var displayedItem = referencedItems.filter('[data-reference="' + reference  + '"]');
            
            displayedItem.removeClass('hidden');
            displayedItem.removeAttr('disabled');
        },
        gridDisplayNameForTitle: function (title) {
            return title === 'AD' ? 'ADL' : title;
        } 
    });
})(jQuery);